import { render, staticRenderFns } from "./DefaultLocations.vue?vue&type=template&id=4e56e0e1&"
import script from "./DefaultLocations.vue?vue&type=script&lang=js&"
export * from "./DefaultLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports